import React from "react";
// import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Dashboard from "./Dashboard";
// import User from "./User";
// import Account from "./Account";
// import Terms from "./Terms";
// import Privacy from "./Privacy";
// import ThankYou from "./ThankYou";
// import Deletion from "./Deletion";
// import Response from "./Response";
// import HowItWorks from "./HowItWorks";
// import FAQ from "./FAQ";
// import Security from "./Security";
// import VerifyEmail from "./VerifyEmail";
// import Home from "./Home";
import Login from "./Login";
import Account from "./Account/Account";
import Projects from "./Projects/Projects";
import ProjectDashboard from "./ProjectDashboard/ProjectDashboard";
import Assets from "./Assets/Assets";
import Issues from "./Issues/Issues";
import Issue from "./Issue/Issue";
import Observations from "./Observations/Observations";
import Observation from "./Observation/Observation";
import Equipment from "./Equipment/Equipment";
import Checklist from "./Checklist/Checklist";
import Files from "./Files/Files";
import Checklists from "./Checklists/Checklists";
import ChecklistTemplates from "./ChecklistTemplates/ChecklistTemplates";
import ChecklistTemplateEdit from "./ChecklistTemplates/ChecklistTemplateEdit";
import Feature from "./Feature/Feature";
import { AuthProvider } from "./AuthContext";
import { auth } from "./firebase";
import PrivateRoute from "./PrivateRoute";
import { Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";
import { useAuthState } from "react-firebase-hooks/auth";
import { SnackbarProvider } from "notistack";
import ResponsiveAppBar from "./ResponsiveAppBar";

function App() {
  const [user, loading, error] = useAuthState(auth);
  const [currentProject, setCurrentProject] = React.useState(null);
  const [userData, setUserData] = React.useState(null);
  const saveCurrentProject = (p) => {
    console.log(p);
    setCurrentProject(p);
  };

  const sendUpUserData = (ud) => {
    setUserData(ud);
    // Here you can update the user state or perform other actions as needed
  };
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
        <div style={{ width: "100%", height: "100%" }}>
          <Router>
            <ResponsiveAppBar
              user={user}
              userData={userData}
              loading={loading}
              saveCurrentProject={saveCurrentProject}
              currentProject={currentProject}
            />
            <AuthProvider
              value={{
                user,
                loading,
                error,
                auth,
              }}
            >
              <Routes>
                <Route
                  exact
                  path="/"
                  element={
                    <PrivateRoute>
                      <Projects
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/account"
                  element={
                    <PrivateRoute>
                      <Account
                        user={user}
                        loading={loading}
                        sendUpUserData={sendUpUserData}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/feature"
                  element={
                    <PrivateRoute>
                      <Feature
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                {/* <Route
                  path="/projects"
                  element={
                    <PrivateRoute>
                      <Projects
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                /> */}
                <Route
                  path="/project/:projectId/dashboard"
                  element={
                    <PrivateRoute>
                      <ProjectDashboard
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/:projectId/checklist-templates/:checklistId/edit"
                  element={
                    <PrivateRoute>
                      <ChecklistTemplateEdit
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/:projectId/Checklist-Templates"
                  element={
                    <PrivateRoute>
                      <ChecklistTemplates
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/:projectId/Files"
                  element={
                    <PrivateRoute>
                      <Files
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/:projectId/Checklist/:checklistId"
                  element={
                    <PrivateRoute>
                      <Checklist
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/:projectId/Checklists"
                  element={
                    <PrivateRoute>
                      <Checklists
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/:projectId/Assets"
                  element={
                    <PrivateRoute>
                      <Assets
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/:projectId/Issues"
                  element={
                    <PrivateRoute>
                      <Issues
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/:projectId/Observations"
                  element={
                    <PrivateRoute>
                      <Observations
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/:projectId/Issue/:issueId"
                  element={
                    <PrivateRoute>
                      <Issue
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/:projectId/Observation/:observationId"
                  element={
                    <PrivateRoute>
                      <Observation
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/project/:projectId/Equipment/:equipmentId"
                  element={
                    <PrivateRoute>
                      <Equipment
                        user={user}
                        loading={loading}
                        saveCurrentProject={saveCurrentProject}
                        currentProject={currentProject}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/login"
                  element={
                    user === null ? (
                      <Login /> //<Login/>
                    ) : (
                      <Navigate to="/Account" replace />
                    )
                  }
                />
              </Routes>
            </AuthProvider>
          </Router>
        </div>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
